import { isPartnerPortalDomain } from 'utils/portalUtils'

const isPartner = isPartnerPortalDomain()

const appConfig = {
    apiPrefix: 'https://be.velotrax.sa/api',
    authenticatedEntryPath: '/dashboard',
    partnerEntryPath: '/partner/dashboard',
    unAuthenticatedEntryPath: isPartner ? '/partner/sign-in' : '/sign-in',
    tourPath: '/',
    enableMock: true,
    isPartnerPortal: isPartner,
}
export default appConfig

// export const formatDateTime = (isoString) => {
//   const date = new Date(isoString);
//   const options = {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   };
//   return date.toLocaleString("en-US", options).replace(",", " -");
// };
export const formatDateTime = (isoString, onlyDate = false) => {
  if (!isoString) return "-";


  // Convert ISO string to local time automatically
  const date = new Date(isoString);

  // Extract date parts in LOCAL TIME
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  // Time (local)

  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;

  if (onlyDate) {
    return `${day} ${month} ${year}`;
  }

  return `${day} ${month} ${year}, ${hour12}:${minutes} ${ampm}`;
};